exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-21a52907] table > tbody > tr > td {\n\tcursor: pointer;\n}\ninput[type='texte'][data-v-21a52907] {\n\twidth: 100%;\n\tpadding: 12px 20px;\n\tmargin: 4px 0;\n\tbox-sizing: border-box;\n\tborder: none;\n\tbackground-color: white;\n\tcolor: white;\n}\n.btn1[data-v-21a52907] {\n\tmargin-bottom: 10px;\n\twidth: 250px;\n}\n", ""]);

// exports
